import { useTranslation } from 'react-i18next'
import { MenuItem } from '@/components/common/MenuItem/MenuItem'
import { useExportUsageCostReport } from '../../hooks/useExportUsageCostReport'
import useToastStore from '@/stores/useToastStore/useToastStore'

export type ExportUsageCostReportProps = {
    reportId: string
    onClick?: () => void
}

export const ExportUsageCostReport: React.FC<ExportUsageCostReportProps> = ({
    reportId,
    onClick,
}) => {
    const { t } = useTranslation('translations')
    const addAlert = useToastStore((state) => state.addAlert)
    const { exportUsageCostReport } = useExportUsageCostReport(reportId)

    return (
        <MenuItem
            path="/"
            variant="ghost"
            label={t('common.export_report_dropdown.options.xls')}
            render={({ renderContents }) => (
                <button
                    className="group w-full outline-none"
                    onClick={() => {
                        addAlert({
                            variant: 'success',
                            title: t(
                                'reporting.export_report.success_toast.title'
                            ),
                            description: t(
                                'reporting.export_report.success_toast.description'
                            ),
                        })
                        onClick?.()
                        exportUsageCostReport()
                    }}
                    data-testid="export-xls-button"
                >
                    {renderContents()}
                </button>
            )}
        />
    )
}
